import { render } from "./LinkNavBar.vue?vue&type=template&id=2546bc24&scoped=true&ts=true"
import script from "./LinkNavBar.vue?vue&type=script&lang=ts"
export * from "./LinkNavBar.vue?vue&type=script&lang=ts"

import "./LinkNavBar.vue?vue&type=style&index=0&id=2546bc24&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2546bc24"]])

export default __exports__